import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="bg-forest text-bone mt-32" data-testid="site-footer">
            <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-20">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <div className="font-mono text-xs uppercase tracking-widest opacity-70 mb-6">[ Est. 2025 · Bangalore, India ]</div>
                        <h3 className="font-serif text-4xl lg:text-6xl leading-[1.05] tracking-tight">
                            Paper that <span className="italic">outlives</span> the meal it serves.
                        </h3>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="font-mono text-xs uppercase tracking-widest opacity-70 mb-4">Products</div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/products/paper-salad-bowls" className="hover:text-clay">Paper Salad Bowls</Link></li>
                            <li><Link to="/products/paper-soup-bowls" className="hover:text-clay">Paper Soup Bowls</Link></li>
                            <li><Link to="/products/pet-flat-lids" className="hover:text-clay">PET Flat Lids</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="font-mono text-xs uppercase tracking-widest opacity-70 mb-4">Company</div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/about" className="hover:text-clay">About</Link></li>
                            <li><Link to="/sustainable-packaging" className="hover:text-clay">Sustainability</Link></li>
                            <li><Link to="/custom-printing" className="hover:text-clay">Custom Print</Link></li>
                            <li><Link to="/export" className="hover:text-clay">Export</Link></li>
                            <li><Link to="/blog" className="hover:text-clay">Blog</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="font-mono text-xs uppercase tracking-widest opacity-70 mb-4">Contact</div>
                        <ul className="space-y-2 text-sm">
                            <li>Bangalore, India</li>
                            <li className="pt-2"><Link to="/contact" className="btn-pill border-bone text-bone hover:bg-bone hover:text-forest">Send Enquiry →</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-bone/20 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs font-mono uppercase tracking-widest opacity-70">
                    <div>© {new Date().getFullYear()} The Puro Pack. All rights reserved.</div>
                    <div>Compostable · PE & Aqueous coated · Food safe</div>
                </div>
            </div>
        </footer>
    );
}
